module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return (_vm.jobSearchStatusModal) ? _c('div', {
    staticClass: "modal__wrap--bg cmp-modal",
    class: {
      'is-active': _vm.jobSearchStatusModal
    },
    attrs: {
      "id": "jobSearchStatus-modal-template"
    }
  }, [_c('div', {
    staticClass: "modal-wrap-container modal-wd1020"
  }, [_vm._m(0), _vm._v(" "), _c('div', {
    staticClass: "modal-body-container ht-full"
  }, [_c('div', {
    staticClass: "text-box-section mt-40"
  }, [_vm._v("\n        현재 구직활동에 대한 자신의 상태를 설정해주세요.일자리 몽땅에서는 구직을 희망하시는 분들께 우선적으로 알맞은 일자리를 추천해드리고 있습니다.\n      ")]), _vm._v(" "), _c('div', {
    staticClass: "border-line-box"
  }, [_c('ul', {
    staticClass: "job-search-check"
  }, [_c('li', [_c('label', {
    staticClass: "radio-item"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.jobSearchStatus),
      expression: "jobSearchStatus"
    }],
    attrs: {
      "type": "radio",
      "name": "job_seeking",
      "id": "seeking_yes",
      "value": "SEEKING",
      "title": "구직 희망 중 선택"
    },
    domProps: {
      "checked": _vm._q(_vm.jobSearchStatus, "SEEKING")
    },
    on: {
      "change": function($event) {
        _vm.jobSearchStatus = "SEEKING"
      }
    }
  }), _c('span', {
    staticClass: "custom-radio"
  }), _vm._v("구직 희망 중")]), _vm._v(" "), _vm._m(1)]), _vm._v(" "), _c('li', [_c('label', {
    staticClass: "radio-item"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.jobSearchStatus),
      expression: "jobSearchStatus"
    }],
    attrs: {
      "type": "radio",
      "name": "job_seeking",
      "id": "seeking_no",
      "value": "NOT_SEEKING",
      "title": "구직 의사 없음 선택"
    },
    domProps: {
      "checked": _vm._q(_vm.jobSearchStatus, "NOT_SEEKING")
    },
    on: {
      "change": function($event) {
        _vm.jobSearchStatus = "NOT_SEEKING"
      }
    }
  }), _c('span', {
    staticClass: "custom-radio"
  }), _vm._v("구직 의사 없음")]), _vm._v(" "), _vm._m(2)])])])]), _vm._v(" "), _c('div', {
    staticClass: "modal-footer"
  }, [_c('button', {
    staticClass: "btn btn-secondary btn-md button-wid150",
    attrs: {
      "type": "button"
    },
    on: {
      "click": _vm.close
    }
  }, [_vm._v("\n        취소하기\n      ")]), _vm._v(" "), _c('button', {
    staticClass: "btn btn-primary btn-md button-wid150",
    attrs: {
      "type": "button"
    },
    on: {
      "click": _vm.save
    }
  }, [_vm._v("\n        저장하기\n      ")])]), _vm._v(" "), _c('button', {
    staticClass: "btn btn-close only-icon close-modal",
    attrs: {
      "type": "button",
      "aria-label": "닫기",
      "title": "닫기"
    },
    on: {
      "click": _vm.close
    }
  }, [_c('i', {
    staticClass: "ico ico-x-bl"
  })])])]) : _vm._e()
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "modal-header"
  }, [_c('div', {
    staticClass: "title"
  }, [_vm._v("구직상태 변경")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "box-type bg-primary type-left"
  }, [_c('ul', {
    staticClass: "list-type-dot"
  }, [_c('li', [_vm._v("“적극적으로 구직을 희망합니다!”")]), _vm._v(" "), _c('li', [_vm._v("일자리 몽땅에서 제공하는 일자리 추천 정보를 수신합니다.")])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "box-type bg-primary type-left"
  }, [_c('ul', {
    staticClass: "list-type-dot"
  }, [_c('li', [_vm._v("“현재 구직이 필요하지 않아요. 둘러만 볼게요.”")]), _vm._v(" "), _c('li', [_vm._v("일자리 몽땅에서 제공하는 일자리 추천 정보를 수신하지 않습니다.")])])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-a664a0a0"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/main/member/JobSearchStatusModal.vue
// module id = 1491
// module chunks = 6